/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.33.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { IWizardImportSubscribersLimitsValidation, IWizardImportSubscribersLimitsWarningSettings } from './types/wizardImportSubscribersLimitsTypes';
import { initWizardImportSubscribersLimitsState } from './wizardImportSubscribersLimitsConstant';
import {
    IWizardImportSubscribersLimitsReducer,
} from './wizardImportSubscribersLimitsReducer';

export const makeSelectWizardImportSubscribersLimitsState = 
    (state: IRootReducer): IWizardImportSubscribersLimitsReducer =>
        state.wizardImportSubscribersLimits || initWizardImportSubscribersLimitsState;

export const makeSelectWizardImportSubscribersLimitsWarningSettings = ():
    OutputSelector<IRootReducer, IWizardImportSubscribersLimitsWarningSettings,
        (state: IWizardImportSubscribersLimitsReducer) => IWizardImportSubscribersLimitsWarningSettings> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.warningSettings);

export const makeSelectWizardImportSubscribersLimitsValidation = ():
    OutputSelector<IRootReducer, IWizardImportSubscribersLimitsValidation,
        (state: IWizardImportSubscribersLimitsReducer) => IWizardImportSubscribersLimitsValidation> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.validation);

export const makeSelectWizardImportSubscribersLimitsMaxImportSubscriberAmount = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportSubscribersLimitsReducer) => number> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.maxImportSubscriberAmount);

export const makeSelectWizardImportSubscribersLimitsFileTemplateUrl = ():
    OutputSelector<IRootReducer, string,
        (state: IWizardImportSubscribersLimitsReducer) => string> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.fileTemplateUrl);
        

export const makeSelectWizardImportSubscribersLimitsImportFileFormat = ():
    OutputSelector<IRootReducer, string[],
        (state: IWizardImportSubscribersLimitsReducer) => string[]> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.importFileFormat);

export const makeSelectWizardImportSubscribersLimitsMaxFileName = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportSubscribersLimitsReducer) => number> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.maxFileName);

export const makeSelectWizardImportSubscribersLimitsMaxFileSize = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportSubscribersLimitsReducer) => number> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.maxFileSize);

export const makeSelectWizardImportSubscribersLimitsFileIsLoading = ():
    OutputSelector<IRootReducer, boolean,
        (state: IWizardImportSubscribersLimitsReducer) => boolean> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.fileIsLoading);

export const makeSelectWizardImportSubscribersLimitsFileName = ():
    OutputSelector<IRootReducer, string,
        (state: IWizardImportSubscribersLimitsReducer) => string> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.fileName);

export const makeSelectWizardImportSubscribersLimitsFileRowsAmount = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportSubscribersLimitsReducer) => number> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.fileRowsAmount);

export const makeSelectWizardImportSubscribersLimitsAttachFileErrorCode = ():
    OutputSelector<IRootReducer, string,
        (state: IWizardImportSubscribersLimitsReducer) => string> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.errorCode);

export const makeSelectWizardImportSubscribersLimitsErrorRowsAmount = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportSubscribersLimitsReducer) => number> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.errorRowsAmount);

export const makeSelectWizardImportSubscribersLimitsRemovedRowsAmount = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportSubscribersLimitsReducer) => number> =>
    createSelector(makeSelectWizardImportSubscribersLimitsState, state => state.removedRowsAmount);
